import React from "react";

import Slide from "@mui/material/Slide";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";

// Shared with the profile Change Password modal
import styles from "../../ChangePassword/ChangePassword.module.scss";
import Text from "../../../FormControl/Text/Text";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ResetPassword = (props) => {
  const { showModal, customerName, newPassword, confirmPassword, submitStatus } = props;
  const { onChangePassword, handleCancelClick, handleSubmitClick } = props;

  return (
    <Dialog
      open={showModal}
      TransitionComponent={Transition}
      onClose={handleCancelClick}
      classes={{ paper: styles.modalDialog }}
    >
      <DialogContent className={styles.modalContent}>
        <div className={`text-center ${styles.modalBody}`}>
          <h5 className={`my-3 text-center ${styles.modalTitle}`}>Reset Password</h5>
          <p className="mb-4">
            Set a new password for {customerName}. Give it to the customer directly; no email is sent.
          </p>
          {["newPassword", "confirmPassword"].map((field) => (
            <Text
              key={field}
              type="password"
              label={field === "newPassword" ? "New Password" : "Confirm Password"}
              value={field === "newPassword" ? newPassword : confirmPassword}
              required={true}
              submitStatus={submitStatus}
              onChange={(password) => onChangePassword(field, password)}
            />
          ))}
          <p className="mb-4 text-muted">
            At least 12 characters, with 3 of: uppercase, lowercase, digit, special character.
          </p>
          <button onClick={handleSubmitClick} className="btn pink-btn d-inline-block mb-3 mr-2">
            Reset Password
          </button>
          <button onClick={handleCancelClick} className="btn gray-btn d-inline-block mb-3">
            Cancel
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ResetPassword;
